<template>
  <div class="logo-container">
    <div :class="['logo', { 'is-mobile': isMobileBreakpoint }]">
      <img :src="logo" alt="Lefebvre logo" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useVuetify } from '@/composables/useVuetify'
import { imageURL } from '@/assets/images/url/imageURL'

// COMPOSABLES
const { isMobileBreakpoint } = useVuetify()

// COMPUTED
const logo = computed(() => {
  if (isMobileBreakpoint.value) {
    return imageURL.isotype
  } else {
    return imageURL.logo
  }
})
</script>

<style lang="scss" scoped>
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  flex: 1 0 0;

  .logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    img {
      width: var(--logo-desktop-width, 146.18px);
    }

    &.is-mobile {
      img {
        width: var(--logo-mobile-width, 36px);
      }
    }
  }
}
</style>
